import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityName } from '@shared/enums/entity-name.enum';
import { Entity } from '@shared/models/entity.model';
import { BaseHttpService } from '../http/base-http.service';
import { ChallengeHttpService } from '../http/challenge-http.service';
import { EventHttpService } from '../http/event-http.service';
import { NewsMessagesHttpService } from '../http/news-messages-http.service';
import { OrganizationHttpService } from '../http/organization-http.service';
import { PeopleHttpService } from '../http/people-http.service';
import { VentureHttpService } from '../http/venture.http.service';

@Injectable({
  providedIn: 'root',
})
export class EntityBaseHttpService extends BaseHttpService<Entity> {
  constructor(protected http: HttpClient) {
    super(http);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FactoryService {
  constructor(
    private readonly ventureHttpService: VentureHttpService,
    private readonly eventHttpService: EventHttpService,
    private readonly organizationHttpService: OrganizationHttpService,
    private readonly challengeHttpService: ChallengeHttpService,
    private readonly peopleHttpService: PeopleHttpService,
    private readonly newsMessagesHttpService: NewsMessagesHttpService,
    private readonly baseHttpService: EntityBaseHttpService
  ) {}

  createServiceByEntityName(entityName: EntityName): BaseHttpService<Entity> {
    switch (entityName) {
      case EntityName.Venture:
        return this.ventureHttpService;

      case EntityName.Organization:
        return this.organizationHttpService;

      case EntityName.Challenge:
        return this.challengeHttpService;

      case EntityName.Event:
        return this.eventHttpService;

      case EntityName.Person:
        return this.peopleHttpService;

      case EntityName.News:
      case EntityName.Message:
        return this.newsMessagesHttpService;

      default:
        return this.baseHttpService;
    }
  }
}
